import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Stack } from '@chakra-ui/react';
import { CategoryGrid } from '@client/components/collections/CategoryGrid';
import { ShopGrid } from '@client/components/collections/ShopGrid';
import { SortableListingGrid } from '@client/components/collections/SortableListingGrid';
import { AppError } from '@client/components/feedback/AppError';
import { CategoryBreadcrumb } from '@client/components/navigation/CategoryBreadcrumb';
import { SectionTitle } from '@client/components/textDisplay/SectionTitle';
import { GRID_CONTENT_MAX_WIDTH, GRID_PAGE_PADDING_Y, SECTION_TITLE_GAP, STANDARD_GRID_GAP, } from '@client/constants';
import { useApiClient } from '@client/hooks/useApiClient';
import { useListingView } from '@client/hooks/useListingView';
import { useMinDuration } from '@client/hooks/useMinDuration';
import { useCategories } from '@client/providers/CategoriesProvider';
import { callApi } from '@client/utils/apiUtils';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
export const CategoryPage = () => {
    const navigate = useNavigate();
    const { id: idParam } = useParams();
    if (!idParam) {
        navigate('/');
    }
    const id = idParam;
    const apiClient = useApiClient();
    const { getChildCategories, categoriesLoading, categoriesError } = useCategories();
    const subcategories = getChildCategories(id);
    const [listings, setListings] = useState([]);
    const [shops, setShops] = useState([]);
    const [listingsLoading, setListingsLoading] = useState(true);
    const [listingsError, setListingsError] = useState(null);
    const listingView = useListingView(listings);
    const isLoading = useMinDuration(listingsLoading || categoriesLoading);
    const loadListings = async () => {
        const result = await callApi(apiClient.categories.getListings({ params: { id } }));
        if (result.error !== null) {
            setListingsError(result.error);
        }
        else {
            setListings(result.data.listings);
            setShops(result.data.shops);
        }
        setListingsLoading(false);
    };
    useEffect(() => {
        setListingsLoading(true);
        setListingsError(null);
        setListings([]);
        setShops([]);
        loadListings();
    }, [id]);
    if (categoriesError) {
        return (_jsx(AppError, { title: 'Failed to load categories', content: _jsxs(_Fragment, { children: ["Click", ' ', _jsx(Link, { onClick: () => navigate('/'), style: {
                            textDecoration: 'underline',
                        }, children: "here" }), ' ', "to return to the homepage."] }) }));
    }
    return (_jsxs(Stack, { py: GRID_PAGE_PADDING_Y, px: STANDARD_GRID_GAP, gap: 7, width: "100%", maxW: GRID_CONTENT_MAX_WIDTH, mx: "auto", children: [_jsx(CategoryBreadcrumb, { categoryId: id }), subcategories.length > 0 && (_jsx(CategoryGrid, { categories: subcategories, isLoading: isLoading })), !listingsError && (isLoading || shops.length > 0) && (_jsxs(Stack, { gap: SECTION_TITLE_GAP, children: [_jsx(SectionTitle, { children: "Makers" }), _jsx(ShopGrid, { shops: shops, isLoading: isLoading })] })), listingsError ? (_jsx(AppError, { title: listingsError })) : (_jsx(SortableListingGrid, { view: listingView, heading: _jsx(SectionTitle, { children: "Items" }), isLoading: isLoading, shops: shops }))] }));
};
